import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

export class FormHelper {
  static markChildControlsAsTouched(control: AbstractControl) {
    control.markAsTouched();
    control.markAsDirty();
    control.updateValueAndValidity();
    if (control['controls'] != null) {
      Object.values(control['controls']).forEach((childControl: any) => {
        this.markChildControlsAsTouched(childControl);
      });
    }
  }

  static getFormControl(formFields: FormlyFieldConfig[], questionConfig: FormlyFieldConfig, tabKey: string, pageKey: string, pageIndex: number, sectionKey: string, sectionIndex: number): AbstractControl {
    let questionKey = questionConfig.key.toString();

    let tabsControl = formFields?.[0]?.formControl?.['controls']?.tabs?.['controls'];

    if (tabsControl == null) {
      return undefined;
    }

    let formControl: AbstractControl;

    //Non-repeating page and section.
    if (questionConfig.props.isRepeatingPage === false && questionConfig.props.isRepeatingSection === false) {
      formControl = tabsControl[tabKey]?.controls[pageKey]?.controls[sectionKey]?.controls[questionKey];
    }
    //Else if question in repeating page only.
    else if (questionConfig.props.isRepeatingPage === true && questionConfig.props.isRepeatingSection === false) {
      formControl = tabsControl[tabKey]?.controls[pageKey]?.controls[pageIndex]?.controls[sectionKey]?.controls[questionKey];
    }
    //Else if question in repeating section only.
    else if (questionConfig.props.isRepeatingPage === false && questionConfig.props.isRepeatingSection === true) {
      formControl = tabsControl[tabKey]?.controls[pageKey]?.controls[sectionKey]?.controls[sectionIndex]?.controls[questionKey];
    }
    //Else if question in repeating page and repeating section.
    else if (questionConfig.props.isRepeatingPage === true && questionConfig.props.isRepeatingSection === true) {
      formControl = tabsControl[tabKey]?.controls[pageKey]?.controls[pageIndex]?.controls[sectionKey]?.controls[sectionIndex]?.controls[questionKey];
    }

    return formControl;
  }

  static getSectionFormControl(formFields: FormlyFieldConfig[], sectionConfig: FormlyFieldConfig, tabKey: string, pageKey: string, pageIndex: number, sectionKey: string, sectionIndex: number): AbstractControl {
    // let questionKey = sectionConfig.key.toString();
    //let formRootControl = this.field.parent.parent.parent.parent.formControl;
    let tabsControl = formFields[0]?.formControl['controls']?.tabs['controls']
    let formControl: AbstractControl;

    //Non-repeating page and section.
    if (sectionConfig.props.isRepeatingPage === null || sectionConfig.props.isRepeatingPage === undefined || sectionConfig.props.isRepeatingPage !== true) {
      formControl = tabsControl[tabKey]?.controls[pageKey]?.controls[sectionKey];
    }
    //Else if question in repeating page only.
    else if (sectionConfig.props.isRepeatingPage === true) {
      formControl = tabsControl[tabKey]?.controls[pageKey]?.controls[pageIndex]?.controls[sectionKey];
    }

    return formControl;
  }

  static getResponseValue(model: any, tabKey: string, pageKey: string, pageIndex: number, sectionKey: string, sectionIndex: number, questionKey: string) {
    return this.getSectionValue(model, tabKey, pageKey, pageIndex, sectionKey, sectionIndex)?.[questionKey];
  }

  static getRawResponse(model: any, tabKey: string, pageKey: string, pageIndex: number, sectionKey: string, sectionIndex: number, questionKey: string) {
    const responseValue = this.getResponseValue(model, tabKey, pageKey, pageIndex, sectionKey, sectionIndex, questionKey);
    return typeof responseValue === 'object' && responseValue?.code ? responseValue.code : responseValue?.toString();
  }

  static setResponseValue(model: any, tabKey: string, pageKey: string, pageIndex: number, sectionKey: string, sectionIndex: number, questionKey: string, questionValue: any) {
    //Repeating page only.
    if (pageIndex > -1 && sectionIndex === -1) {
      if (model?.[tabKey]?.[pageKey]?.[pageIndex]?.[sectionKey] != null) {
        model[tabKey][pageKey][pageIndex][sectionKey][questionKey] = questionValue;
      }
    }

    //Repeating section only.
    else if (pageIndex === -1 && sectionIndex > -1) {
      if (model?.[tabKey]?.[pageKey]?.[sectionKey]?.[sectionIndex] != null) {
        model[tabKey][pageKey][sectionKey][sectionIndex][questionKey] = questionValue;
      }
    }

    //Repeating page and repeating section.
    else if (pageIndex > -1 && sectionIndex > -1) {
      if (model?.[tabKey]?.[pageKey]?.[pageIndex]?.[sectionKey]?.[sectionIndex] != null) {
        model[tabKey][pageKey][pageIndex][sectionKey][sectionIndex][questionKey] = questionValue;
      }
    }

    //Page and section are not repeating.
    else {
      if (model?.[tabKey]?.[pageKey]?.[sectionKey] != null) {
        return model[tabKey][pageKey][sectionKey][questionKey] = questionValue;
      }
    }
  }

  private static getPageValue(model: any, tabKey: string, pageKey: string, pageIndex: number) {
    //Repeating page.
    if (pageIndex > -1) {
      return model?.[tabKey]?.[pageKey]?.[pageIndex];
    }
    //Page is are not repeating.
    return model?.[tabKey]?.[pageKey];
  }

  private static getSectionValue(model: any, tabKey: string, pageKey: string, pageIndex: number, sectionKey: string, sectionIndex: number) {
    //Repeating section.
    if (sectionIndex > -1) {
      return this.getPageValue(model, tabKey, pageKey, pageIndex)?.[sectionKey]?.[sectionIndex];
    }

    //Section is not repeating.
    return this.getPageValue(model, tabKey, pageKey, pageIndex)?.[sectionKey];
  }
}
